<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="是否删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'delFlag', validatorRules.delFlag]" placeholder="请输入是否删除"></a-input>
        </a-form-item>
        <a-form-item label="访客主表id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'visitorInfoId', validatorRules.visitorInfoId]" placeholder="请输入访客主表id"></a-input>
        </a-form-item>
        <a-form-item label="审批人编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'approvalNo', validatorRules.approvalNo]" placeholder="请输入审批人编号"></a-input>
        </a-form-item>
        <a-form-item label="审批人名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'approvalName', validatorRules.approvalName]" placeholder="请输入审批人名称"></a-input>
        </a-form-item>
        <a-form-item label="审批状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'status', validatorRules.status]" placeholder="请输入审批状态"></a-input>
        </a-form-item>
        <a-form-item label="审批原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入审批原因"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: "BusVisitorApprovalModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          delFlag: {rules: [
          ]},
          visitorInfoId: {rules: [
          ]},
          approvalNo: {rules: [
          ]},
          approvalName: {rules: [
          ]},
          status: {rules: [
          ]},
          remarks: {rules: [
          ]},
        },
        url: {
          add: "/visitor/busVisitorApproval/add",
          edit: "/visitor/busVisitorApproval/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'delFlag','visitorInfoId','approvalNo','approvalName','status','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'delFlag','visitorInfoId','approvalNo','approvalName','status','remarks'))
      },

      
    }
  }
</script>